import { fadeInWidthExpandTransition as a } from "../../../_styles/transitions/fade-in-width-expand.cssr.js";
import { iconSwitchTransition as i } from "../../../_styles/transitions/icon-switch.cssr.js";
import { c as o, cB as n, cM as e, cE as r, cNotM as t } from "../../../_utils/cssr/index.js";
import { isBrowser as d } from "../../../_utils/env/is-browser.js";
const v = o([n("button", `
 margin: 0;
 font-weight: var(--n-font-weight);
 line-height: 1;
 font-family: inherit;
 padding: var(--n-padding);
 height: var(--n-height);
 font-size: var(--n-font-size);
 border-radius: var(--n-border-radius);
 color: var(--n-text-color);
 background-color: var(--n-color);
 width: var(--n-width);
 white-space: nowrap;
 outline: none;
 position: relative;
 z-index: auto;
 border: none;
 display: inline-flex;
 flex-wrap: nowrap;
 flex-shrink: 0;
 align-items: center;
 justify-content: center;
 user-select: none;
 -webkit-user-select: none;
 text-align: center;
 cursor: pointer;
 text-decoration: none;
 transition:
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 opacity .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 `, [e("color", [r("border", {
  borderColor: "var(--n-border-color)"
}), e("disabled", [r("border", {
  borderColor: "var(--n-border-color-disabled)"
})]), t("disabled", [o("&:focus", [r("state-border", {
  borderColor: "var(--n-border-color-focus)"
})]), o("&:hover", [r("state-border", {
  borderColor: "var(--n-border-color-hover)"
})]), o("&:active", [r("state-border", {
  borderColor: "var(--n-border-color-pressed)"
})]), e("pressed", [r("state-border", {
  borderColor: "var(--n-border-color-pressed)"
})])])]), e("disabled", {
  backgroundColor: "var(--n-color-disabled)",
  color: "var(--n-text-color-disabled)"
}, [r("border", {
  border: "var(--n-border-disabled)"
})]), t("disabled", [o("&:focus", {
  backgroundColor: "var(--n-color-focus)",
  color: "var(--n-text-color-focus)"
}, [r("state-border", {
  border: "var(--n-border-focus)"
})]), o("&:hover", {
  backgroundColor: "var(--n-color-hover)",
  color: "var(--n-text-color-hover)"
}, [r("state-border", {
  border: "var(--n-border-hover)"
})]), o("&:active", {
  backgroundColor: "var(--n-color-pressed)",
  color: "var(--n-text-color-pressed)"
}, [r("state-border", {
  border: "var(--n-border-pressed)"
})]), e("pressed", {
  backgroundColor: "var(--n-color-pressed)",
  color: "var(--n-text-color-pressed)"
}, [r("state-border", {
  border: "var(--n-border-pressed)"
})])]), e("loading", "cursor: wait;"), n("base-wave", `
 pointer-events: none;
 top: 0;
 right: 0;
 bottom: 0;
 left: 0;
 animation-iteration-count: 1;
 animation-duration: var(--n-ripple-duration);
 animation-timing-function: var(--n-bezier-ease-out), var(--n-bezier-ease-out);
 `, [e("active", {
  zIndex: 1,
  animationName: "button-wave-spread, button-wave-opacity"
})]), d && "MozBoxSizing" in document.createElement("div").style ? o("&::moz-focus-inner", {
  border: 0
}) : null, r("border, state-border", `
 position: absolute;
 left: 0;
 top: 0;
 right: 0;
 bottom: 0;
 border-radius: inherit;
 transition: border-color .3s var(--n-bezier);
 pointer-events: none;
 `), r("border", {
  border: "var(--n-border)"
}), r("state-border", {
  border: "var(--n-border)",
  borderColor: "#0000",
  zIndex: 1
}), r("icon", `
 margin: var(--n-icon-margin);
 margin-left: 0;
 height: var(--n-icon-size);
 width: var(--n-icon-size);
 max-width: var(--n-icon-size);
 font-size: var(--n-icon-size);
 position: relative;
 flex-shrink: 0;
 `, [n("icon-slot", `
 height: var(--n-icon-size);
 width: var(--n-icon-size);
 position: absolute;
 left: 0;
 top: 50%;
 transform: translateY(-50%);
 display: flex;
 align-items: center;
 justify-content: center;
 `, [i({
  top: "50%",
  originalTransform: "translateY(-50%)"
})]), a()]), r("content", `
 display: flex;
 align-items: center;
 flex-wrap: nowrap;
 min-width: 0;
 `, [o("~", [r("icon", {
  margin: "var(--n-icon-margin)",
  marginRight: 0
})])]), e("block", `
 display: flex;
 width: 100%;
 `), e("dashed", [r("border, state-border", {
  borderStyle: "dashed !important"
})]), e("disabled", {
  cursor: "not-allowed",
  opacity: "var(--n-opacity-disabled)"
})]), o("@keyframes button-wave-spread", {
  from: {
    boxShadow: "0 0 0.5px 0 var(--n-ripple-color)"
  },
  to: {
    // don't use exact 5px since chrome will display the animation with glitches
    boxShadow: "0 0 0.5px 4.5px var(--n-ripple-color)"
  }
}), o("@keyframes button-wave-opacity", {
  from: {
    opacity: "var(--n-wave-opacity)"
  },
  to: {
    opacity: 0
  }
})]);
export {
  v as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/button/src/styles/index.cssr.js
// module id = 1593
// module chunks = 41